module.exports = __webpack_public_path__ + "static/media/img-2.e63f2ed9.jpg";